import React from "react";
import "./NotFound404.css";

export default function NotFound404() {
  return (
    <div className="nf-container">
      {/* Animated Crystal Background */}
      <div className="crystal-background">
        {Array.from({ length: 20 }).map((_, index) => (
          <div
            key={index}
            className={`crystal crystal-${index % 4 + 1}`}
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${8 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      {/* Floating Particles */}
      <div className="particles-container">
        {Array.from({ length: 50 }).map((_, index) => (
          <div
            key={index}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="nf-content">
        <h1 className="nf-heading">404</h1>
        <h2 className="nf-title">Page Not Found</h2>
        <p className="nf-desc">
          Sorry, we couldn't find the information you're looking for. It might have been
          moved, renamed, or it never existed.
        </p>
        
        {/* <div className="nf-actions">
          <button className="nf-btn primary" onClick={() => window.history.back()}>
            Go Back
          </button>
          <button className="nf-btn ghost" onClick={() => window.location.href = '/'}>
            Home Page
          </button>
        </div> */}
      </div>

      {/* Glowing Orbs */}
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>
      <div className="orb orb-3"></div>
    </div>
  );
}